import React from 'react'
import * as blueprint from '@adc/blueprint'
import classnames from 'classnames/bind'
import styles from '../styles.scss'

const cx = classnames.bind(styles)

export class OptionFee extends blueprint.listing.badges.OptionFee {
  get content() {
    return (
      <div>
        Getting to know your potential home better:
        <ul className={cx('badge-bullet-list')}>
          <li>
            After your offer's accepted, hire a professional to inspect the
            home.
          </li>
          <li>
            Always obtain proper permission and follow all applicable laws and
            regulations when viewing properties.
          </li>
          <li>
            You can work with the seller to arrange a convenient time for you
            and your inspector to view the home.
          </li>
          <li>
            An inspector can help check everything from the roof to the
            foundation.
          </li>
          <li>You will have specified days to complete this step.</li>
          <li>
            Have any concerns? You'll have an opportunity to discuss the
            inspection information with the seller, as needed.
          </li>
        </ul>
      </div>
    )
  }
}
